// Comprehensive political leaders age database
// Data current as of 2024

export const POLITICAL_LEADERS_AGE = {
    // U.S. SENATORS - Complete age data
    senators: {
        'AL': [
            { name: 'Tommy Tuberville', party: 'R', age: 70, birthYear: 1954, birthDate: '1954-09-18', gender: 'M' },
            { name: 'Katie Britt', party: 'R', age: 42, birthYear: 1982, birthDate: '1982-02-02', gender: 'F' }
        ],
        'AK': [
            { name: 'Lisa Murkowski', party: 'R', age: 67, birthYear: 1957, birthDate: '1957-05-22', gender: 'F' },
            { name: 'Dan Sullivan', party: 'R', age: 59, birthYear: 1964, birthDate: '1964-11-13', gender: 'M' }
        ],
        'AZ': [
            { name: 'Ruben Gallego', party: 'D', age: 44, birthYear: 1979, birthDate: '1979-11-20', gender: 'M' },
            { name: 'Mark Kelly', party: 'D', age: 60, birthYear: 1964, birthDate: '1964-02-21', gender: 'M' }
        ],
        'AR': [
            { name: 'John Boozman', party: 'R', age: 73, birthYear: 1950, birthDate: '1950-12-10', gender: 'M' },
            { name: 'Tom Cotton', party: 'R', age: 47, birthYear: 1977, birthDate: '1977-05-13', gender: 'M' }
        ],
        'CA': [
            { name: 'Alex Padilla', party: 'D', age: 51, birthYear: 1973, birthDate: '1973-03-22', gender: 'M' },
            { name: 'Adam Schiff', party: 'D', age: 64, birthYear: 1960, birthDate: '1960-06-22', gender: 'M' }
        ],
        'CO': [
            { name: 'Michael Bennet', party: 'D', age: 59, birthYear: 1964, birthDate: '1964-11-28', gender: 'M' },
            { name: 'John Hickenlooper', party: 'D', age: 72, birthYear: 1952, birthDate: '1952-02-07', gender: 'M' }
        ],
        'CT': [
            { name: 'Richard Blumenthal', party: 'D', age: 78, birthYear: 1946, birthDate: '1946-02-13', gender: 'M' },
            { name: 'Chris Murphy', party: 'D', age: 51, birthYear: 1973, birthDate: '1973-08-03', gender: 'M' }
        ],
        'DE': [
            { name: 'Tom Carper', party: 'D', age: 77, birthYear: 1947, birthDate: '1947-01-23', gender: 'M' },
            { name: 'Chris Coons', party: 'D', age: 61, birthYear: 1963, birthDate: '1963-09-09', gender: 'M' }
        ],
        'FL': [
            { name: 'Marco Rubio', party: 'R', age: 53, birthYear: 1971, birthDate: '1971-05-28', gender: 'M' },
            { name: 'Rick Scott', party: 'R', age: 71, birthYear: 1952, birthDate: '1952-12-01', gender: 'M' }
        ],
        'GA': [
            { name: 'Jon Ossoff', party: 'D', age: 37, birthYear: 1987, birthDate: '1987-02-16', gender: 'M' },
            { name: 'Raphael Warnock', party: 'D', age: 55, birthYear: 1969, birthDate: '1969-07-23', gender: 'M' }
        ],
        'HI': [
            { name: 'Brian Schatz', party: 'D', age: 52, birthYear: 1972, birthDate: '1972-10-20', gender: 'M' },
            { name: 'Mazie Hirono', party: 'D', age: 76, birthYear: 1947, birthDate: '1947-11-03', gender: 'F' }
        ],
        'ID': [
            { name: 'Mike Crapo', party: 'R', age: 73, birthYear: 1951, birthDate: '1951-05-20', gender: 'M' },
            { name: 'Jim Risch', party: 'R', age: 81, birthYear: 1943, birthDate: '1943-05-03', gender: 'M' }
        ],
        'IL': [
            { name: 'Dick Durbin', party: 'D', age: 79, birthYear: 1944, birthDate: '1944-11-21', gender: 'M' },
            { name: 'Tammy Duckworth', party: 'D', age: 56, birthYear: 1968, birthDate: '1968-03-12', gender: 'F' }
        ],
        'IN': [
            { name: 'Todd Young', party: 'R', age: 52, birthYear: 1972, birthDate: '1972-08-24', gender: 'M' },
            { name: 'Jim Banks', party: 'R', age: 45, birthYear: 1979, birthDate: '1979-07-16', gender: 'M' }
        ],
        'IA': [
            { name: 'Chuck Grassley', party: 'R', age: 91, birthYear: 1933, birthDate: '1933-09-17', gender: 'M' },
            { name: 'Joni Ernst', party: 'R', age: 54, birthYear: 1970, birthDate: '1970-07-01', gender: 'F' }
        ],
        'KS': [
            { name: 'Jerry Moran', party: 'R', age: 70, birthYear: 1954, birthDate: '1954-05-29', gender: 'M' },
            { name: 'Roger Marshall', party: 'R', age: 64, birthYear: 1960, birthDate: '1960-08-09', gender: 'M' }
        ],
        'KY': [
            { name: 'Mitch McConnell', party: 'R', age: 82, birthYear: 1942, birthDate: '1942-02-20', gender: 'M' },
            { name: 'Rand Paul', party: 'R', age: 61, birthYear: 1963, birthDate: '1963-01-07', gender: 'M' }
        ],
        'LA': [
            { name: 'Bill Cassidy', party: 'R', age: 67, birthYear: 1957, birthDate: '1957-09-28', gender: 'M' },
            { name: 'John Kennedy', party: 'R', age: 72, birthYear: 1951, birthDate: '1951-11-21', gender: 'M' }
        ],
        'ME': [
            { name: 'Susan Collins', party: 'R', age: 71, birthYear: 1952, birthDate: '1952-12-07', gender: 'F' },
            { name: 'Angus King', party: 'I', age: 80, birthYear: 1944, birthDate: '1944-03-31', gender: 'M' }
        ],
        'MD': [
            { name: 'Ben Cardin', party: 'D', age: 81, birthYear: 1943, birthDate: '1943-10-05', gender: 'M' },
            { name: 'Angela Alsobrooks', party: 'D', age: 53, birthYear: 1971, birthDate: '1971-02-23', gender: 'F' }
        ],
        'MA': [
            { name: 'Elizabeth Warren', party: 'D', age: 75, birthYear: 1949, birthDate: '1949-06-22', gender: 'F' },
            { name: 'Ed Markey', party: 'D', age: 78, birthYear: 1946, birthDate: '1946-07-11', gender: 'M' }
        ],
        'MI': [
            { name: 'Debbie Stabenow', party: 'D', age: 74, birthYear: 1950, birthDate: '1950-04-29', gender: 'F' },
            { name: 'Elissa Slotkin', party: 'D', age: 48, birthYear: 1976, birthDate: '1976-07-10', gender: 'F' }
        ],
        'MN': [
            { name: 'Amy Klobuchar', party: 'D', age: 64, birthYear: 1960, birthDate: '1960-05-25', gender: 'F' },
            { name: 'Tina Smith', party: 'D', age: 66, birthYear: 1958, birthDate: '1958-03-04', gender: 'F' }
        ],
        'MS': [
            { name: 'Roger Wicker', party: 'R', age: 73, birthYear: 1951, birthDate: '1951-07-05', gender: 'M' },
            { name: 'Cindy Hyde-Smith', party: 'R', age: 65, birthYear: 1959, birthDate: '1959-05-10', gender: 'F' }
        ],
        'MO': [
            { name: 'Josh Hawley', party: 'R', age: 44, birthYear: 1979, birthDate: '1979-12-31', gender: 'M' },
            { name: 'Eric Schmitt', party: 'R', age: 49, birthYear: 1975, birthDate: '1975-06-20', gender: 'M' }
        ],
        'MT': [
            { name: 'Jon Tester', party: 'D', age: 68, birthYear: 1956, birthDate: '1956-08-21', gender: 'M' },
            { name: 'Tim Sheehy', party: 'R', age: 38, birthYear: 1986, birthDate: '1986-01-01', gender: 'M' }
        ],
        'NE': [
            { name: 'Deb Fischer', party: 'R', age: 73, birthYear: 1951, birthDate: '1951-03-01', gender: 'F' },
            { name: 'Pete Ricketts', party: 'R', age: 60, birthYear: 1964, birthDate: '1964-08-19', gender: 'M' }
        ],
        'NV': [
            { name: 'Catherine Cortez Masto', party: 'D', age: 60, birthYear: 1964, birthDate: '1964-03-29', gender: 'F' },
            { name: 'Jacky Rosen', party: 'D', age: 67, birthYear: 1957, birthDate: '1957-08-02', gender: 'F' }
        ],
        'NH': [
            { name: 'Jeanne Shaheen', party: 'D', age: 77, birthYear: 1947, birthDate: '1947-01-28', gender: 'F' },
            { name: 'Maggie Hassan', party: 'D', age: 66, birthYear: 1958, birthDate: '1958-02-27', gender: 'F' }
        ],
        'NJ': [
            { name: 'Bob Menendez', party: 'D', age: 70, birthYear: 1954, birthDate: '1954-01-01', gender: 'M' },
            { name: 'Cory Booker', party: 'D', age: 55, birthYear: 1969, birthDate: '1969-04-27', gender: 'M' }
        ],
        'NM': [
            { name: 'Martin Heinrich', party: 'D', age: 53, birthYear: 1971, birthDate: '1971-10-17', gender: 'M' },
            { name: 'Ben Ray Luján', party: 'D', age: 52, birthYear: 1972, birthDate: '1972-06-07', gender: 'M' }
        ],
        'NY': [
            { name: 'Chuck Schumer', party: 'D', age: 74, birthYear: 1950, birthDate: '1950-11-23', gender: 'M' },
            { name: 'Kirsten Gillibrand', party: 'D', age: 57, birthYear: 1966, birthDate: '1966-12-09', gender: 'F' }
        ],
        'NC': [
            { name: 'Thom Tillis', party: 'R', age: 64, birthYear: 1960, birthDate: '1960-08-30', gender: 'M' },
            { name: 'Ted Budd', party: 'R', age: 53, birthYear: 1971, birthDate: '1971-10-21', gender: 'M' }
        ],
        'ND': [
            { name: 'John Hoeven', party: 'R', age: 67, birthYear: 1957, birthDate: '1957-03-13', gender: 'M' },
            { name: 'Kevin Cramer', party: 'R', age: 63, birthYear: 1961, birthDate: '1961-01-21', gender: 'M' }
        ],
        'OH': [
            { name: 'Sherrod Brown', party: 'D', age: 72, birthYear: 1952, birthDate: '1952-11-09', gender: 'M' },
            { name: 'Bernie Moreno', party: 'R', age: 57, birthYear: 1967, birthDate: '1967-02-14', gender: 'M' }
        ],
        'OK': [
            { name: 'James Lankford', party: 'R', age: 56, birthYear: 1968, birthDate: '1968-03-04', gender: 'M' },
            { name: 'Markwayne Mullin', party: 'R', age: 47, birthYear: 1977, birthDate: '1977-07-26', gender: 'M' }
        ],
        'OR': [
            { name: 'Ron Wyden', party: 'D', age: 75, birthYear: 1949, birthDate: '1949-05-03', gender: 'M' },
            { name: 'Jeff Merkley', party: 'D', age: 68, birthYear: 1956, birthDate: '1956-10-24', gender: 'M' }
        ],
        'PA': [
            { name: 'Bob Casey Jr.', party: 'D', age: 64, birthYear: 1960, birthDate: '1960-04-13', gender: 'M' },
            { name: 'John Fetterman', party: 'D', age: 55, birthYear: 1969, birthDate: '1969-08-15', gender: 'M' }
        ],
        'RI': [
            { name: 'Jack Reed', party: 'D', age: 75, birthYear: 1949, birthDate: '1949-11-12', gender: 'M' },
            { name: 'Sheldon Whitehouse', party: 'D', age: 69, birthYear: 1955, birthDate: '1955-10-20', gender: 'M' }
        ],
        'SC': [
            { name: 'Lindsey Graham', party: 'R', age: 69, birthYear: 1955, birthDate: '1955-07-09', gender: 'M' },
            { name: 'Tim Scott', party: 'R', age: 59, birthYear: 1965, birthDate: '1965-09-19', gender: 'M' }
        ],
        'SD': [
            { name: 'John Thune', party: 'R', age: 63, birthYear: 1961, birthDate: '1961-01-07', gender: 'M' },
            { name: 'Mike Rounds', party: 'R', age: 70, birthYear: 1954, birthDate: '1954-10-24', gender: 'M' }
        ],
        'TN': [
            { name: 'Marsha Blackburn', party: 'R', age: 72, birthYear: 1952, birthDate: '1952-06-06', gender: 'F' },
            { name: 'Bill Hagerty', party: 'R', age: 65, birthYear: 1959, birthDate: '1959-08-14', gender: 'M' }
        ],
        'TX': [
            { name: 'John Cornyn', party: 'R', age: 72, birthYear: 1952, birthDate: '1952-02-02', gender: 'M' },
            { name: 'Ted Cruz', party: 'R', age: 53, birthYear: 1970, birthDate: '1970-12-22', gender: 'M' }
        ],
        'UT': [
            { name: 'Mike Lee', party: 'R', age: 53, birthYear: 1971, birthDate: '1971-06-04', gender: 'M' },
            { name: 'John Curtis', party: 'R', age: 64, birthYear: 1960, birthDate: '1960-05-10', gender: 'M' }
        ],
        'VT': [
            { name: 'Bernie Sanders', party: 'I', age: 83, birthYear: 1941, birthDate: '1941-09-08', gender: 'M' },
            { name: 'Peter Welch', party: 'D', age: 77, birthYear: 1947, birthDate: '1947-05-02', gender: 'M' }
        ],
        'VA': [
            { name: 'Mark Warner', party: 'D', age: 69, birthYear: 1954, birthDate: '1954-12-15', gender: 'M' },
            { name: 'Tim Kaine', party: 'D', age: 66, birthYear: 1958, birthDate: '1958-02-26', gender: 'M' }
        ],
        'WA': [
            { name: 'Patty Murray', party: 'D', age: 74, birthYear: 1950, birthDate: '1950-10-11', gender: 'F' },
            { name: 'Maria Cantwell', party: 'D', age: 66, birthYear: 1958, birthDate: '1958-10-13', gender: 'F' }
        ],
        'WV': [
            { name: 'Shelley Moore Capito', party: 'R', age: 70, birthYear: 1953, birthDate: '1953-11-26', gender: 'F' },
            { name: 'Jim Justice', party: 'R', age: 73, birthYear: 1951, birthDate: '1951-04-27', gender: 'M' }
        ],
        'WI': [
            { name: 'Ron Johnson', party: 'R', age: 69, birthYear: 1955, birthDate: '1955-04-08', gender: 'M' },
            { name: 'Tammy Baldwin', party: 'D', age: 62, birthYear: 1962, birthDate: '1962-02-11', gender: 'F' }
        ],
        'WY': [
            { name: 'John Barrasso', party: 'R', age: 72, birthYear: 1952, birthDate: '1952-07-21', gender: 'M' },
            { name: 'Cynthia Lummis', party: 'R', age: 70, birthYear: 1954, birthDate: '1954-09-10', gender: 'F' }
        ]
    },

    // GOVERNORS - Complete age data
    governors: {
        'AL': { name: 'Kay Ivey', party: 'R', age: 80, birthYear: 1944, birthDate: '1944-10-15', gender: 'F' },
        'AK': { name: 'Mike Dunleavy', party: 'R', age: 63, birthYear: 1961, birthDate: '1961-05-05', gender: 'M' },
        'AZ': { name: 'Katie Hobbs', party: 'D', age: 54, birthYear: 1969, birthDate: '1969-12-28', gender: 'F' },
        'AR': { name: 'Sarah Huckabee Sanders', party: 'R', age: 42, birthYear: 1982, birthDate: '1982-08-13', gender: 'F' },
        'CA': { name: 'Gavin Newsom', party: 'D', age: 57, birthYear: 1967, birthDate: '1967-10-10', gender: 'M' },
        'CO': { name: 'Jared Polis', party: 'D', age: 49, birthYear: 1975, birthDate: '1975-05-12', gender: 'M' },
        'CT': { name: 'Ned Lamont', party: 'D', age: 70, birthYear: 1954, birthDate: '1954-01-03', gender: 'M' },
        'DE': { name: 'John Carney', party: 'D', age: 68, birthYear: 1956, birthDate: '1956-05-20', gender: 'M' },
        'FL': { name: 'Ron DeSantis', party: 'R', age: 46, birthYear: 1978, birthDate: '1978-09-14', gender: 'M' },
        'GA': { name: 'Brian Kemp', party: 'R', age: 61, birthYear: 1963, birthDate: '1963-11-02', gender: 'M' },
        'HI': { name: 'Josh Green', party: 'D', age: 54, birthYear: 1970, birthDate: '1970-02-11', gender: 'M' },
        'ID': { name: 'Brad Little', party: 'R', age: 70, birthYear: 1954, birthDate: '1954-02-15', gender: 'M' },
        'IL': { name: 'J. B. Pritzker', party: 'D', age: 59, birthYear: 1965, birthDate: '1965-01-19', gender: 'M' },
        'IN': { name: 'Eric Holcomb', party: 'R', age: 56, birthYear: 1968, birthDate: '1968-05-02', gender: 'M' },
        'IA': { name: 'Kim Reynolds', party: 'R', age: 65, birthYear: 1959, birthDate: '1959-08-04', gender: 'F' },
        'KS': { name: 'Laura Kelly', party: 'D', age: 74, birthYear: 1950, birthDate: '1950-01-24', gender: 'F' },
        'KY': { name: 'Andy Beshear', party: 'D', age: 47, birthYear: 1977, birthDate: '1977-11-29', gender: 'M' },
        'LA': { name: 'Jeff Landry', party: 'R', age: 53, birthYear: 1970, birthDate: '1970-12-23', gender: 'M' },
        'ME': { name: 'Janet Mills', party: 'D', age: 76, birthYear: 1947, birthDate: '1947-12-30', gender: 'F' },
        'MD': { name: 'Wes Moore', party: 'D', age: 46, birthYear: 1978, birthDate: '1978-10-15', gender: 'M' },
        'MA': { name: 'Maura Healey', party: 'D', age: 53, birthYear: 1971, birthDate: '1971-02-08', gender: 'F' },
        'MI': { name: 'Gretchen Whitmer', party: 'D', age: 53, birthYear: 1971, birthDate: '1971-08-23', gender: 'F' },
        'MN': { name: 'Tim Walz', party: 'D', age: 60, birthYear: 1964, birthDate: '1964-04-06', gender: 'M' },
        'MS': { name: 'Tate Reeves', party: 'R', age: 50, birthYear: 1974, birthDate: '1974-06-05', gender: 'M' },
        'MO': { name: 'Mike Parson', party: 'R', age: 69, birthYear: 1955, birthDate: '1955-09-17', gender: 'M' },
        'MT': { name: 'Greg Gianforte', party: 'R', age: 63, birthYear: 1961, birthDate: '1961-04-17', gender: 'M' },
        'NE': { name: 'Jim Pillen', party: 'R', age: 68, birthYear: 1955, birthDate: '1955-12-31', gender: 'M' },
        'NV': { name: 'Joe Lombardo', party: 'R', age: 61, birthYear: 1962, birthDate: '1962-11-08', gender: 'M' },
        'NH': { name: 'Chris Sununu', party: 'R', age: 50, birthYear: 1974, birthDate: '1974-11-05', gender: 'M' },
        'NJ': { name: 'Phil Murphy', party: 'D', age: 67, birthYear: 1957, birthDate: '1957-08-16', gender: 'M' },
        'NM': { name: 'Michelle Lujan Grisham', party: 'D', age: 65, birthYear: 1959, birthDate: '1959-10-24', gender: 'F' },
        'NY': { name: 'Kathy Hochul', party: 'D', age: 66, birthYear: 1958, birthDate: '1958-08-27', gender: 'F' },
        'NC': { name: 'Roy Cooper', party: 'D', age: 67, birthYear: 1957, birthDate: '1957-06-13', gender: 'M' },
        'ND': { name: 'Doug Burgum', party: 'R', age: 68, birthYear: 1956, birthDate: '1956-08-01', gender: 'M' },
        'OH': { name: 'Mike DeWine', party: 'R', age: 77, birthYear: 1947, birthDate: '1947-01-05', gender: 'M' },
        'OK': { name: 'Kevin Stitt', party: 'R', age: 51, birthYear: 1972, birthDate: '1972-12-28', gender: 'M' },
        'OR': { name: 'Tina Kotek', party: 'D', age: 58, birthYear: 1966, birthDate: '1966-09-30', gender: 'F' },
        'PA': { name: 'Josh Shapiro', party: 'D', age: 51, birthYear: 1973, birthDate: '1973-06-20', gender: 'M' },
        'RI': { name: 'Dan McKee', party: 'D', age: 73, birthYear: 1951, birthDate: '1951-06-16', gender: 'M' },
        'SC': { name: 'Henry McMaster', party: 'R', age: 77, birthYear: 1947, birthDate: '1947-05-27', gender: 'M' },
        'SD': { name: 'Kristi Noem', party: 'R', age: 52, birthYear: 1971, birthDate: '1971-11-30', gender: 'F' },
        'TN': { name: 'Bill Lee', party: 'R', age: 65, birthYear: 1959, birthDate: '1959-10-09', gender: 'M' },
        'TX': { name: 'Greg Abbott', party: 'R', age: 67, birthYear: 1957, birthDate: '1957-11-13', gender: 'M' },
        'UT': { name: 'Spencer Cox', party: 'R', age: 49, birthYear: 1975, birthDate: '1975-07-11', gender: 'M' },
        'VT': { name: 'Phil Scott', party: 'R', age: 66, birthYear: 1958, birthDate: '1958-08-04', gender: 'M' },
        'VA': { name: 'Glenn Youngkin', party: 'R', age: 57, birthYear: 1966, birthDate: '1966-12-09', gender: 'M' },
        'WA': { name: 'Jay Inslee', party: 'D', age: 73, birthYear: 1951, birthDate: '1951-02-09', gender: 'M' },
        'WV': { name: 'Jim Justice', party: 'R', age: 73, birthYear: 1951, birthDate: '1951-04-27', gender: 'M' },
        'WI': { name: 'Tony Evers', party: 'D', age: 73, birthYear: 1951, birthDate: '1951-11-05', gender: 'M' },
        'WY': { name: 'Mark Gordon', party: 'R', age: 67, birthYear: 1957, birthDate: '1957-03-14', gender: 'M' }
    },

    // HOUSE REPRESENTATIVES - Sample data for largest delegations
    // Note: Full data would include all 435 representatives
    houseRepresentatives: {
        'CA': [
            { district: 1, name: 'Doug LaMalfa', party: 'R', age: 64, birthYear: 1960, gender: 'M' },
            { district: 2, name: 'Jared Huffman', party: 'D', age: 60, birthYear: 1964, gender: 'M' },
            { district: 3, name: 'Kevin Kiley', party: 'R', age: 39, birthYear: 1985, gender: 'M' },
            { district: 4, name: 'Mike Thompson', party: 'D', age: 73, birthYear: 1951, gender: 'M' },
            { district: 5, name: 'Tom McClintock', party: 'R', age: 68, birthYear: 1956, gender: 'M' },
            { district: 6, name: 'Ami Bera', party: 'D', age: 59, birthYear: 1965, gender: 'M' },
            { district: 7, name: 'Doris Matsui', party: 'D', age: 80, birthYear: 1944, gender: 'F' },
            { district: 8, name: 'John Garamendi', party: 'D', age: 79, birthYear: 1945, gender: 'M' },
            { district: 9, name: 'Josh Harder', party: 'D', age: 38, birthYear: 1986, gender: 'M' },
            { district: 10, name: 'Mark DeSaulnier', party: 'D', age: 72, birthYear: 1952, gender: 'M' },
            { district: 11, name: 'Nancy Pelosi', party: 'D', age: 84, birthYear: 1940, gender: 'F' },
            { district: 12, name: 'Lateefah Simon', party: 'D', age: 47, birthYear: 1977, gender: 'F' },
            // ... additional representatives
        ],
        'TX': [
            { district: 1, name: 'Nathaniel Moran', party: 'R', age: 50, birthYear: 1974, gender: 'M' },
            { district: 2, name: 'Dan Crenshaw', party: 'R', age: 40, birthYear: 1984, gender: 'M' },
            { district: 3, name: 'Keith Self', party: 'R', age: 71, birthYear: 1953, gender: 'M' },
            { district: 4, name: 'Pat Fallon', party: 'R', age: 56, birthYear: 1967, gender: 'M' },
            { district: 5, name: 'Lance Gooden', party: 'R', age: 41, birthYear: 1982, gender: 'M' },
            { district: 6, name: 'Jake Ellzey', party: 'R', age: 54, birthYear: 1970, gender: 'M' },
            { district: 7, name: 'Lizzie Fletcher', party: 'D', age: 49, birthYear: 1975, gender: 'F' },
            { district: 8, name: 'Morgan Luttrell', party: 'R', age: 49, birthYear: 1975, gender: 'M' },
            { district: 9, name: 'Al Green', party: 'D', age: 77, birthYear: 1947, gender: 'M' },
            { district: 10, name: 'Michael McCaul', party: 'R', age: 62, birthYear: 1962, gender: 'M' },
            // ... additional representatives
        ],
        'FL': [
            { district: 1, name: 'Matt Gaetz', party: 'R', age: 42, birthYear: 1982, gender: 'M' },
            { district: 2, name: 'Neal Dunn', party: 'R', age: 71, birthYear: 1953, gender: 'M' },
            { district: 3, name: 'Kat Cammack', party: 'R', age: 36, birthYear: 1988, gender: 'F' },
            { district: 4, name: 'Aaron Bean', party: 'R', age: 57, birthYear: 1967, gender: 'M' },
            { district: 5, name: 'John Rutherford', party: 'R', age: 72, birthYear: 1952, gender: 'M' },
            { district: 6, name: 'Michael Waltz', party: 'R', age: 50, birthYear: 1974, gender: 'M' },
            { district: 7, name: 'Cory Mills', party: 'R', age: 44, birthYear: 1980, gender: 'M' },
            { district: 8, name: 'Bill Posey', party: 'R', age: 76, birthYear: 1947, gender: 'M' },
            { district: 9, name: 'Darren Soto', party: 'D', age: 46, birthYear: 1978, gender: 'M' },
            { district: 10, name: 'Maxwell Frost', party: 'D', age: 27, birthYear: 1997, gender: 'M' },
            // ... additional representatives
        ],
        'NY': [
            { district: 1, name: 'Nick LaLota', party: 'R', age: 46, birthYear: 1978, gender: 'M' },
            { district: 2, name: 'Andrew Garbarino', party: 'R', age: 40, birthYear: 1984, gender: 'M' },
            { district: 3, name: 'Tom Suozzi', party: 'D', age: 62, birthYear: 1962, gender: 'M' },
            { district: 4, name: 'Anthony D\'Esposito', party: 'R', age: 42, birthYear: 1982, gender: 'M' },
            { district: 5, name: 'Gregory Meeks', party: 'D', age: 71, birthYear: 1953, gender: 'M' },
            { district: 6, name: 'Grace Meng', party: 'D', age: 49, birthYear: 1975, gender: 'F' },
            { district: 7, name: 'Nydia Velázquez', party: 'D', age: 71, birthYear: 1953, gender: 'F' },
            { district: 8, name: 'Hakeem Jeffries', party: 'D', age: 54, birthYear: 1970, gender: 'M' },
            { district: 9, name: 'Yvette Clarke', party: 'D', age: 60, birthYear: 1964, gender: 'F' },
            { district: 10, name: 'Dan Goldman', party: 'D', age: 48, birthYear: 1976, gender: 'M' },
            { district: 11, name: 'Nicole Malliotakis', party: 'R', age: 44, birthYear: 1980, gender: 'F' },
            { district: 12, name: 'Jerry Nadler', party: 'D', age: 77, birthYear: 1947, gender: 'M' },
            // ... additional representatives
        ],
        'IA': [
            { district: 1, name: 'Mariannette Miller-Meeks', party: 'R', age: 69, birthYear: 1955, birthDate: '1955-09-06', gender: 'F', termEnd: '2025' },
            { district: 2, name: 'Ashley Hinson', party: 'R', age: 41, birthYear: 1983, birthDate: '1983-06-27', gender: 'F', termEnd: '2025' },
            { district: 3, name: 'Zach Nunn', party: 'R', age: 45, birthYear: 1979, birthDate: '1979-05-04', gender: 'M', termEnd: '2025' },
            { district: 4, name: 'Randy Feenstra', party: 'R', age: 55, birthYear: 1969, birthDate: '1969-01-14', gender: 'M', termEnd: '2025' }
        ]
    }
};

// Helper functions
export const calculateAge = (birthDate) => {
    const birth = new Date(birthDate);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
        age--;
    }
    return age;
};

export const getAverageAge = (group) => {
    const ages = group.map(person => person.age).filter(age => age !== undefined);
    return ages.reduce((sum, age) => sum + age, 0) / ages.length;
};

export const getGenerationBreakdown = (group) => {
    const generations = {
        'Silent Generation (1928-1945)': 0,
        'Baby Boomers (1946-1964)': 0,
        'Generation X (1965-1980)': 0,
        'Millennials (1981-1996)': 0,
        'Generation Z (1997-2012)': 0
    };
    
    group.forEach(person => {
        const birthYear = person.birthYear;
        if (birthYear >= 1928 && birthYear <= 1945) generations['Silent Generation (1928-1945)']++;
        else if (birthYear >= 1946 && birthYear <= 1964) generations['Baby Boomers (1946-1964)']++;
        else if (birthYear >= 1965 && birthYear <= 1980) generations['Generation X (1965-1980)']++;
        else if (birthYear >= 1981 && birthYear <= 1996) generations['Millennials (1981-1996)']++;
        else if (birthYear >= 1997 && birthYear <= 2012) generations['Generation Z (1997-2012)']++;
    });
    
    return generations;
};

export const getOldestAndYoungest = (group) => {
    const sorted = [...group].sort((a, b) => b.age - a.age);
    return {
        oldest: sorted[0],
        youngest: sorted[sorted.length - 1]
    };
};

// Statistics functions
export const getPoliticalAgeStatistics = () => {
    // Senate statistics
    const allSenators = [];
    Object.values(POLITICAL_LEADERS_AGE.senators).forEach(stateSenators => {
        allSenators.push(...stateSenators);
    });
    
    // Governor statistics
    const allGovernors = Object.values(POLITICAL_LEADERS_AGE.governors);
    
    // House statistics (partial)
    const allHouseReps = [];
    Object.values(POLITICAL_LEADERS_AGE.houseRepresentatives).forEach(stateReps => {
        allHouseReps.push(...stateReps);
    });
    
    return {
        senate: {
            averageAge: getAverageAge(allSenators),
            oldestMember: getOldestAndYoungest(allSenators).oldest,
            youngestMember: getOldestAndYoungest(allSenators).youngest,
            generationBreakdown: getGenerationBreakdown(allSenators),
            totalMembers: allSenators.length
        },
        governors: {
            averageAge: getAverageAge(allGovernors),
            oldestGovernor: getOldestAndYoungest(allGovernors).oldest,
            youngestGovernor: getOldestAndYoungest(allGovernors).youngest,
            generationBreakdown: getGenerationBreakdown(allGovernors),
            totalGovernors: allGovernors.length
        },
        house: {
            averageAge: getAverageAge(allHouseReps),
            oldestMember: getOldestAndYoungest(allHouseReps).oldest,
            youngestMember: getOldestAndYoungest(allHouseReps).youngest,
            generationBreakdown: getGenerationBreakdown(allHouseReps),
            sampleSize: allHouseReps.length
        }
    };
};

export default POLITICAL_LEADERS_AGE;